(function(){
  function init(){
    var progress=document.querySelector('[data-rs-progress]');
    var mobileCta=document.querySelector('[data-rs-mobile-cta]');
    var closing=document.querySelector('[data-rs-closing]');
    function update(){
      var doc=document.documentElement;
      var max=doc.scrollHeight-doc.clientHeight;
      if(progress) progress.style.width=(max>0?(doc.scrollTop/max)*100:0)+'%';
      if(mobileCta){
        var closeTop=closing?closing.getBoundingClientRect().top:99999;
        mobileCta.classList.toggle('is-visible',window.scrollY>650&&closeTop>window.innerHeight*.7);
      }
    }
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fades=document.querySelectorAll('.rs-fade');
    if(reduce||!('IntersectionObserver' in window)){fades.forEach(function(el){el.classList.add('is-visible')});}
    else{
      var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}});},{threshold:.08});
      fades.forEach(function(el){observer.observe(el);});
    }
    update();
    window.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
